import { Injectable } from '@angular/core'
import { MbProductTabApplicationsAdapter } from './mb-product-tab-applications.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbProductTabApplicationsConnector {

  constructor (protected adapter: MbProductTabApplicationsAdapter) {
  }

  get (productCode: string, maxCount?: number) {
    return this.adapter.load(productCode, maxCount)
  }
}
